import { buttonBaseClasses, cardHeaderClasses, typographyClasses, type Theme } from "@mui/material"
import { SimpleWidgetCardTheme } from "../../../definitions/components.types"
import { simpleWidgetCardClasses } from "../../../themeTypes"

export const createSimpleWidgetCardTheme = (_: Theme): SimpleWidgetCardTheme => ({
    styleOverrides: {
        root: {
            padding: ".25em",
        },
        card: {
            borderRadius: "0px",
            border: "0px",
            boxShadow: "none",
            "&:hover": {
                boxShadow: "0 0 0 1px #085cf0",
            },
            padding: 0,
        },
        content: {
            padding: 15,
        },
        header: {
            background: "#000",
            padding: "7px 15px",
            color: "#fff",
            [`> .${cardHeaderClasses.content}`]: {
                textTransform: "uppercase",
                [`.${typographyClasses.root}`]: {
                    letterSpacing: ".5px",
                    ".MuiBox-root": {
                        [`.${typographyClasses.root}`]: {
                            opacity: 1,
                        },
                    },
                },
            },
            [`> .${cardHeaderClasses.action}`]: {
                ".MuiBox-root": {
                    [`.${typographyClasses.root}`]: {
                        opacity: 1,
                    },
                    ".MuiBox-root": {
                        [`.${buttonBaseClasses.root}`]: {
                            color: "#fff",
                        },
                    },
                },
            },
        },
    },
    variants: [
        {
            props: { widgetVariant: "startpage" },
            style: {
                [`.${simpleWidgetCardClasses.header}`]: {
                    [`>.${cardHeaderClasses.action}`]: {
                        marginRight: -8,
                    },
                },
            },
        },
    ],
})
